export const LPG_REQUEST_A_CALLBACK_FOR_HOME =
  'https://www.originenergy.com.au/for-home/lpg.html#getQuote';
export const LPG_FOR_BUSINESS = 'https://www.originenergy.com.au/business/lpg.html';
